import { SlotReelSymbol } from "../../../../constants/enum/slot";
import { SlotReelSymbols } from "../../../../constants/slot";

export const shuffleArray = (array: SlotReelSymbol[]) => {
  for (let i = array.length - 1; i > 0; i--) {
    // Generate a random index between 0 and i
    const j = Math.floor(Math.random() * (i + 1));
    // Swap elements at i and j
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
};

const enforceMinimumDistance = (
  array: SlotReelSymbol[],
  minDistance: number
) => {
  const result: SlotReelSymbol[] = [];
  const lastSeen: Map<SlotReelSymbol, number> = new Map(); // Tracks the last position of each item

  for (let i = 0; i < array.length; i++) {
    const item = array[i];
    const lastPosition = lastSeen.get(item);

    // If the item violates the minimum distance, find a valid position
    if (lastPosition !== undefined && i - lastPosition < minDistance) {
      // Find a valid swap position
      let swapIndex = -1;
      for (let j = i + 1; j < array.length; j++) {
        const candidate = array[j];
        const candidateLastPosition = lastSeen.get(candidate);

        // Check if swapping would make both items valid
        if (
          (candidateLastPosition === undefined ||
            j - candidateLastPosition >= minDistance) &&
          (lastPosition === undefined || j - lastPosition >= minDistance)
        ) {
          swapIndex = j;
          break;
        }
      }

      // If a valid swap position is found, swap the items
      if (swapIndex !== -1) {
        [array[i], array[swapIndex]] = [array[swapIndex], array[i]];
      } else {
        throw new Error(
          "Cannot enforce minimum distance with the given input."
        );
      }
    }

    // Add the item to the result and update its last position
    result.push(array[i]);
    lastSeen.set(array[i], i);
  }

  return result;
};

export const getRandomSymbols = (
  duplicates: number,
  maxRetries: number = 100
) => {
  const symbols: SlotReelSymbol[] = [];

  // Create the array with duplicates
  for (let i = 0; i < duplicates; i++) {
    symbols.push(...SlotReelSymbols);
  }

  let shuffledSymbols = shuffleArray(symbols);
  let retries = 0;

  while (retries < maxRetries) {
    try {
      // Try to enforce the minimum distance
      return enforceMinimumDistance(shuffledSymbols, 3);
    } catch (error) {
      shuffledSymbols = shuffleArray(symbols);
      retries++;
    }
  }

  throw new Error(
    "Failed to generate a valid arrangement after maximum retries."
  );
};
